import React, {Component} from 'react';

import supportList from '../utils/support_list';
import Tutorial from './Tutorial';
import './Main.css';

export default class Main extends Component{
    render(){
        return (
            <div>
                <div className="help">
                    <div className="support">
                        {supportList.map((img, index)=>{
                            return <img src={img.icon} key={index} alt=""/>
                        })}
                    </div>
                </div>
                <Tutorial />
            </div>
        )
    }
}